import { useState } from 'react';
import { useAppStore } from '../store/appStore';
import { estimatePrint, formatDuration } from '../export/estimate';
import { runExport } from '../export/runExport';
import { IconClock } from '../ui/icons';

export function PrintSummary() {
  const objects = useAppStore((s) => s.objects);
  const settings = useAppStore((s) => s.settings);
  const viewMode = useAppStore((s) => s.viewMode);
  const [busy, setBusy] = useState(false);
  const est = estimatePrint(objects, settings);

  async function onExport() {
    setBusy(true);
    try {
      await runExport();
    } finally {
      setBusy(false);
    }
  }

  return (
    <aside className={`print-summary ${viewMode === 'export' ? 'emphasis' : ''}`} data-testid="print-summary">
      <div className="summary-time">
        <IconClock size={22} />
        <div>
          <div className="time-value">{objects.length ? formatDuration(est.approxMinutes) : '—'}</div>
          <div className="time-meta">
            {objects.length ? `${est.filamentGrams}g · ${est.filamentMetres}m` : 'No model'}
            <em>estimate</em>
          </div>
        </div>
      </div>
      <button
        type="button"
        className="primary export-cta"
        data-testid="export-btn"
        disabled={busy}
        onClick={() => void onExport()}
      >
        {busy ? 'Exporting…' : 'Export .3mf'}
      </button>
    </aside>
  );
}
